import * as React from 'react';
import i18n from 'i18n';
import styles from 'views/Analytics/Placeholder/AnalyticsReadOnly.module.css';
import clsx from 'clsx';
import BzmIcon from '../../../components/icons/BzmIcon';

const AnalyticsReadOnly = () => {
  return (
    <div className={clsx(styles.AnalyticsReadonly, 'd-flex justify-content-center align-items-center')}>
      <div className="text-center">
        <BzmIcon variant={'icon-bzm-info'} className={styles.NoDataIcon} />
        <h3 className="font-size-xjb">{i18n.t('analytics:readonly.title')}</h3>
        <div className="p-2 w-100 bd-highlight text-center" style={{ maxWidth: '280px' }}>
          <p> {i18n.t('analytics:readonly.message')}</p>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsReadOnly;
